module.exports = __webpack_public_path__ + "img/control-panel-light-01.1a55f06c.jpg";